export enum WorkspaceRightSideCard {
  FeatureStyling = 'featureStyling',
  SelectLayer = 'selectLayer',
  LayerProperties = 'layerProperties',
  FeatureInfo = 'featureInfo',
  Dataset = 'dataset',
  None = 'none',
}
